module.exports = __webpack_public_path__ + "img/KIDIWI_services-09.8271a22e.png";